import React from 'react';
import { Button, Modal } from 'antd';

// import { playSelectionSound } from '../../../utils/sounds';
export const titles = {
  personality: 'Personality Analysis',
  behaviorPattern: 'Thought Pattern',
  cognitiveDistortion: 'Blind-Spot Analysis',
  unmetNeedsMapping: 'Personalized Roadmap',
};

export default function AnalysisReadyModal({ isOpen, onClose, onViewNow, type = 'personality' }) {
  const handleViewNow = () => {
    // playSelectionSound();
    onClose();
    onViewNow();
    // TODO: Implement navigation to PersonalityAnalysis screen if needed
  };

  const handleContinueChatting = () => {
    // playSelectionSound();
    onClose();
  };

  return (
    <Modal width={400} open={isOpen} onCancel={onClose} footer={false}>
      <div className="flex flex-col items-center pt-4 px-4">
        {/* New! Badge */}
        <div className="bg-pink-200 px-4 py-1 rounded-full mb-4">
          <span className="text-black font-semibold text-sm">New!</span>
        </div>
        {/* Title */}
        <h2 className="text-2xl font-bold text-black text-center mb-3">Your {titles[type]} is Ready!</h2>
        {/* Description */}
        <p className="text-base text-gray-700 text-center mb-16">
          This analysis will be available on your homepage if you want to view it later.
        </p>
        {/* Buttons */}
        <div className="w-full flex flex-col gap-4">
          <Button
            type="primary"
            className="w-full h-14 rounded-full bg-black text-white font-semibold text-lg transition hover:bg-gray-900"
            onClick={handleViewNow}
          >
            View Now
          </Button>
          <Button
            className="w-full h-14 rounded-full bg-gray-100 text-black font-semibold text-lg transition hover:bg-gray-200"
            onClick={handleContinueChatting}
            type="text"
          >
            Continue Chatting
          </Button>
        </div>
      </div>
    </Modal>
  );
}
